export class StudioOptionsModel {
  public id: string;

  constructor(
    public label: string,
    public value: string | number,
    public type: 'category' | 'organization' | 'collection' | 'user',
    public organizationId: number = null
  ) {
    this.id = `${type}|${value || ''}|${organizationId || ''}`;
  }
}
